import session from '../../services/session';

export default {
  login: false,
  loginError: false,
  userSignedIn: session.isAuthenticated()
};



// WEBPACK FOOTER //
// ./src/reducers/user/user-initialState.js